// extracted by mini-css-extract-plugin
export default {"headerContainer":"Header_headerContainer__6KVaw","headerWrapper":"Header_headerWrapper__3Fvyg","header":"Header_header__d+igc","navContainer":"Header_navContainer__+Cj0F"};